// The table view's state lives in the page URL (?filter=col:op:value&sort=-col&offset=&limit=),
// so a foreign-key link, the back button and a shared link all open the same rows. The same
// parameters go to GET .../data/tables/{table}/rows and .../export.csv (operate/browse.py).

export const OPS = [
  { value: "eq", label: "=" },
  { value: "ne", label: "≠" },
  { value: "lt", label: "<" },
  { value: "gt", label: ">" },
  { value: "contains", label: "contains" },
  { value: "is_null", label: "is empty" },
];
export const PAGE_SIZES = [25, 50, 100, 250, 500];
export const DEFAULT_LIMIT = 50;

export function parseFilter(s) {
  const [column, op, ...rest] = String(s).split(":");
  return { column, op, value: rest.length ? rest.join(":") : null };
}

export function formatFilter({ column, op, value }) {
  if (value == null || (op === "is_null" && value === "")) return `${column}:${op}`;
  return `${column}:${op}:${value}`;
}

export function opLabel(op) {
  return (OPS.find(o => o.value === op) || { label: op }).label;
}

/** {filters, sort, offset, limit} of the page's URLSearchParams. */
export function readState(params) {
  const limit = parseInt(params.get("limit"), 10);
  const offset = parseInt(params.get("offset"), 10);
  return {
    filters: params.getAll("filter"),
    sort: params.get("sort") || "",
    limit: PAGE_SIZES.includes(limit) ? limit : DEFAULT_LIMIT,
    offset: Number.isFinite(offset) && offset > 0 ? offset : 0,
  };
}

/** The query string (without "?") for the page URL and the API; empty parts are left out. */
export function query({ filters = [], sort = "", offset = 0, limit = DEFAULT_LIMIT }, { paging = true } = {}) {
  const p = new URLSearchParams();
  filters.forEach(f => p.append("filter", f));
  if (sort) p.set("sort", sort);
  if (paging && limit !== DEFAULT_LIMIT) p.set("limit", String(limit));
  if (paging && offset) p.set("offset", String(offset));
  return p.toString();
}

/** The next sort after clicking `column`: ascending, then descending, then off. */
export function nextSort(sort, column) {
  if (sort === column) return `-${column}`;
  if (sort === `-${column}`) return "";
  return column;
}

/** The page URL of the row a foreign-key value points to. */
export function referenceLink(projectId, fk, value) {
  const p = new URLSearchParams();
  p.append("filter", formatFilter({ column: fk.column, op: "eq", value: String(value) }));
  return `/projects/${projectId}/data/${encodeURIComponent(fk.table)}?${p.toString()}`;
}
